import React from 'react';
import {Icon, Link} from '@shopify/polaris';
import {
  Routes,
  fetchTaxonomy,
} from 'sections/services-marketplace/experts/utilities';
import {Service} from 'sections/types';

import styles from './Breadcrumbs.scss';

interface OwnProps {
  services: Service[];
}

const separator = (
  <span className={styles.BreadcrumbItem}>
    <Icon source="chevronRight" color="inkLighter" />
  </span>
);

export default function Breadcrumbs({services}: OwnProps) {
  const taxonomy = fetchTaxonomy();

  return services ? (
    <div className={styles.Breadcrumbs}>
      {services.map((service, idx) => (
        <React.Fragment key={service.handle}>
          {idx > 0 && separator}
          <span className={styles.BreadcrumbItem}>
            <Link
              monochrome
              url={Routes.servicePath(taxonomy, service.handle)}
              key={service.handle}
            >
              {service.shortLabel}
            </Link>
          </span>
        </React.Fragment>
      ))}
    </div>
  ) : null;
}
